export default __webpack_public_path__ + "static/media/3670797f3ccbffb9.c34fb7bd9d97506ee33faed022480fbe.svg";